import * as MODULES from '../module-codes'
import axios from 'axios'

export const state = () => ({
    characters: [],
    ringingURL: '',
    activeCalls: [],
    videoResponses: [],
    askedQuestions: [],
    videoOn: false,
})

export const getters = {
}

export const actions = {
    addVideoResponse: ({ commit, dispatch }, payload) => {
        return new Promise(function(resolve, reject) {
            let formData = new FormData()
            formData.append('video', payload.video)
            axios
            .post('/api/file/videoRecorder/upload', formData, {
                headers: {
                'Content-Type': 'multipart/form-data',
                },
            })
            .then((res) => {
                if (res.exception) {
                    reject(res)
                }
                else {
                    payload.video = res.data.path
                    payload.convertedVideo = res.data.converted_path
                    commit('ADD_VIDEO_CALL_RESPONSE', payload)
                    dispatch('updateModuleInDB')
                    resolve();
                }
            })
            .catch((err) => {
                reject(err);
            })
        }) 
    },
    addNewCall: ({ commit, dispatch }, payload) => {
        commit('ADD_NEW_VIDEO_CALL', payload)
        dispatch('updateModuleInDB')
    },
    completeCall: ({ commit, dispatch }, payload) => {
        commit('REMOVE_VIDEO_CALL', payload)
        dispatch('updateModuleInDB')
        dispatch("events/processEvent", { eventId: payload.event_id }, { root: true });
    },
    askQuestion: ({ commit, dispatch }, payload) => {
        commit('VIDEO_CALL_ASK_QUESTION', payload)
        dispatch('updateModuleInDB')
    },
    updateModuleInDB: async ({ state, rootState }) => {
        let content = {
            activeCalls: state.activeCalls,
            videoResponses: state.videoResponses,
            askedQuestions: state.askedQuestions
        }
        await axios.post('/api/updateModule', {
            params: {
                moduleState: content,
                moduleName: MODULES.VIDEO_CALL,
                pcs: localStorage.getItem('pcs'),
                classId: rootState.auth.classId,
            } 
        })
    },
    populateVideoCallFromDB: async ({ commit }) => {
        axios.post('/api/pcs/videoCall', {
            params: {
                pcs: localStorage.getItem('pcs')
            }
        }).then(res => {
            commit("SET_VIDEO_CALL_MODULE_DATA", res.data['settings'])
        })
    },
    populateFromDB: async ({ commit, dispatch }, payload) => {
        dispatch('populateVideoCallFromDB')
        if (payload) {
            commit('SET_VIDEO_CALL_USER_CONTENT', payload)
        }
    },
}

export const mutations = {
    SET_VIDEO_CALL_MODULE_DATA(state, payload) {
        state.characters = payload.characters
        state.ringingURL = payload.ringingURL
    },
    SET_VIDEO_CALL_USER_CONTENT(state, payload) {
        state.activeCalls = payload.activeCalls
        state.videoResponses = payload.videoResponses
        state.askedQuestions = payload.askedQuestions
        state.videoOn = payload.videoOn
    },
    ADD_VIDEO_CALL_RESPONSE(state, payload) {
        state.videoResponses.push(payload)
    },
    ADD_NEW_VIDEO_CALL(state, payload) {
        state.activeCalls.push(payload)
    },
    VIDEO_CALL_ASK_QUESTION(state, payload) {
        state.askedQuestions.push(payload)
    },
    REMOVE_VIDEO_CALL(state, payload) {
        let index = state.activeCalls.findIndex((call) => {
            return (call.videoURL === payload.videoURL)
        })
        if (index !== -1) {
            state.activeCalls.splice(index, 1)
        }
        state.askedQuestions = state.askedQuestions.filter((question) => {
            question.callEventId !== payload.event_id
        })
    },
    CLEAR_STATE: state => {
        state.characters = []
        state.ringingURL = ''
        state.activeCalls = []
        state.videoResponses = []
    },
}